import React from 'react'
import { shape, string } from 'prop-types'
import MdPlace from 'react-icons/lib/md/place'

const AutoCompleteItems = ({ formattedSuggestion }) => (
  <div className="autocomplete_suggestion-item">
    <MdPlace color="black" />
    <strong>{formattedSuggestion.mainText}</strong>{' '}
    <small className="text-muted">{formattedSuggestion.secondaryText}</small>
  </div>
)

AutoCompleteItems.propTypes = {
  formattedSuggestion: shape({
    mainText: string.isRequired,
    secondaryText: string.isRequired,
  }),
}

export default AutoCompleteItems



// WEBPACK FOOTER //
// ./src/components/PlacesAutoComplete/AutoCompleteItems.jsx